/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MessageActionDTO } from './messageActionDTO';


export interface AnswerDTO { 
    id: string;
    type: AnswerDTO.TypeEnum;
    'default'?: boolean;
    action?: MessageActionDTO;
}
export namespace AnswerDTO {
    export const TypeEnum = {
        OK: 'OK',
        CANCEL: 'CANCEL'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


